import React, { useState } from 'react';
import { X, Plus } from 'lucide-react';
import { createManualTarefa } from '../services/apiService';

interface Props {
  onClose: () => void;
  onCreated: () => void;
}

export const NewTarefaModal: React.FC<Props> = ({ onClose, onCreated }) => {
  const [title, setTitle] = useState('');
  const [severity, setSeverity] = useState('info');
  const [dueDate, setDueDate] = useState('');
  const [description, setDescription] = useState('');
  const [actionUrl, setActionUrl] = useState('');
  const [tagsInput, setTagsInput] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleCreate = async () => {
    if (!title.trim()) {
      setError('Título é obrigatório');
      return;
    }
    setSubmitting(true);
    try {
      await createManualTarefa({
        title: title.trim(),
        severity,
        due_date: dueDate || undefined,
        description: description.trim(),
        action_url: actionUrl.trim(),
        tags: tagsInput.split(',').map((s) => s.trim()).filter(Boolean),
      });
      onCreated();
    } catch (e: any) {
      setError(e?.response?.data?.detail || 'Erro ao criar');
      setSubmitting(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full">
        <div className="flex items-center justify-between px-4 py-3 border-b border-gray-200">
          <h3 className="font-semibold text-gray-900 flex items-center gap-2">
            <Plus className="h-5 w-5" /> Nova tarefa manual
          </h3>
          <button onClick={onClose} className="p-1 hover:bg-gray-100 rounded">
            <X className="h-5 w-5" />
          </button>
        </div>

        <div className="p-4 space-y-3">
          <div>
            <label className="text-xs text-gray-500 block mb-1">Título *</label>
            <input
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder="ex: Ligar pra Caroline sobre PIX devolvido"
              className="w-full px-2 py-1.5 border border-gray-300 rounded text-sm"
              autoFocus
            />
          </div>

          <div className="grid grid-cols-2 gap-2">
            <div>
              <label className="text-xs text-gray-500 block mb-1">Severidade</label>
              <select
                value={severity}
                onChange={(e) => setSeverity(e.target.value)}
                className="w-full px-2 py-1.5 border border-gray-300 rounded text-sm"
              >
                <option value="info">Info</option>
                <option value="warning">Warning</option>
                <option value="critical">Critical</option>
              </select>
            </div>
            <div>
              <label className="text-xs text-gray-500 block mb-1">Vencimento</label>
              <input
                type="date"
                value={dueDate}
                onChange={(e) => setDueDate(e.target.value)}
                className="w-full px-2 py-1.5 border border-gray-300 rounded text-sm"
              />
            </div>
          </div>

          <div>
            <label className="text-xs text-gray-500 block mb-1">Descrição</label>
            <textarea
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Detalhes opcionais..."
              rows={2}
              className="w-full px-2 py-1.5 border border-gray-300 rounded text-sm"
            />
          </div>

          <div>
            <label className="text-xs text-gray-500 block mb-1">Link / Ação (opcional)</label>
            <input
              type="text"
              value={actionUrl}
              onChange={(e) => setActionUrl(e.target.value)}
              placeholder="ex: /lancamentos ou https://..."
              className="w-full px-2 py-1.5 border border-gray-300 rounded text-sm"
            />
          </div>

          <div>
            <label className="text-xs text-gray-500 block mb-1">Tags (vírgula)</label>
            <input
              type="text"
              value={tagsInput}
              onChange={(e) => setTagsInput(e.target.value)}
              placeholder="ex: softcon, fiscal, urgente"
              className="w-full px-2 py-1.5 border border-gray-300 rounded text-sm"
            />
          </div>

          {error && (
            <div className="text-xs text-red-700 bg-red-50 border border-red-200 px-2 py-1 rounded">
              {error}
            </div>
          )}
        </div>

        <div className="px-4 py-3 border-t border-gray-200 flex justify-end gap-2">
          <button onClick={onClose} className="px-3 py-1.5 text-sm border border-gray-300 rounded hover:bg-gray-50">
            Cancelar
          </button>
          <button
            onClick={handleCreate}
            disabled={submitting || !title.trim()}
            className="px-3 py-1.5 text-sm bg-green-600 text-white rounded hover:bg-green-700 disabled:opacity-50"
          >
            {submitting ? 'Criando...' : 'Criar tarefa'}
          </button>
        </div>
      </div>
    </div>
  );
};
